import React from 'react'
import { useFormContext } from 'react-hook-form'

export default function Row({ company }) {
  const { register, clearErrors } = useFormContext()

  const handleRowClick = () => {
    document.getElementById(`company-${company.id}`).click()
  }

  return (
    <>
      <tr onClick={handleRowClick}>
        <td>
          <input
            type="radio"
            {...register('company_id', {
              required: "can't be blank",
              onChange: () => {
                clearErrors('base')
              },
            })}
            id={`company-${company.id}`}
            value={company.id}
          ></input>
        </td>
        <td>{company.name}</td>
        <td>
          {company.company_aliases.map((alias, key) => (
            <div key={key}>{alias.name}</div>
          ))}
        </td>
        <td>{company.logo_url && <img src={company.logo_url} width={32}></img>}</td>
        <td>{company.company_type}</td>
        <td>{company.status}</td>
      </tr>
    </>
  )
}
